import { create } from "../../../../../common/utils/zustand_state_manager";
import {
  InitializePaginationProperties,
  InitializeSetPaginationProperties,
  PaginationProperties,
  SetPaginationProperties,
} from "../../../../../common/utils/pagination_property";

/**
 * useMaquinasEquipCadastroPrincipalPagination
 */

type State = PaginationProperties;

type Actions = SetPaginationProperties;

export const useMaquinasEquipCadastroPrincipalPagination = create<State & Actions>((set) => ({
  ...InitializePaginationProperties(),
  ...InitializeSetPaginationProperties(set),
}));
